module.exports = __webpack_public_path__ + "img/5b.d3a0d7fc.jpg";